module.exports = __webpack_public_path__ + "img/right_03.2814836c.png";